var render = function render(){var _vm=this,_c=_vm._self._c;return _c('KChip',{staticClass:"pr-0",attrs:{"href":_vm.href,"x-small":"","target":"_blank","icon":"mdi-open-in-new"}})
}
var staticRenderFns = []

export { render, staticRenderFns }